<template>
  <div class="menu-item" :class="{ disabled: disabled }">
    <span class="icon">
      <slot name="icon"></slot>
    </span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*  click() {
      if (!this.disabled) {
        this.$emit('click')
      }
    } */
  }
}
</script>
<style lang="scss" scoped>
@use '../../sass/base/_colors.scss' as *;
@use '../../sass/helpers/_variables.scss' as *;

.menu-item {
  //  padding: 6px;
  padding-right: 12px;
  padding-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative; // so z-index works
  z-index: 2; // so it overlaps the arrow of the parent menu
  height: 40px;
  width: 220px;
  transition: background-color 0.5s;
  font-size: 0.82rem;
  font-weight: 500;
  color: #4f4f4f;

  .icon {
    text-align: center;
    margin-right: 4px;
  }

  &:hover {
    color: var(--sub-color);
  }

  &.disabled {
    cursor: default;
    color: $main-disabled;

    &:hover {
      color: $main-disabled;
    }
  }
}

@media (max-width: $mobile-max-width) {
  .menu-item {
    width: 100vw;
  }
}
</style>
